/* unplugin-vue-components disabled */import script from "./CrsConvert.vue?vue&type=script&setup=true&lang=js"
export * from "./CrsConvert.vue?vue&type=script&setup=true&lang=js"

import "./CrsConvert.vue?vue&type=style&index=0&id=087139fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087139fa"]])

export default __exports__